<template>
  <el-footer>
    <span class="el-footer__text">Kalkınma Yatırım Bankası A.Ş. Copyright &copy; 2020</span>
    <span class="el-footer__text"><span class="icon-phone"></span> 0 (216) 636 87 00</span>
  </el-footer>
</template>
<script>
export default {};
</script>
<style lang="scss"></style>
